const initialState = {
  status: "invalid",
};

export default (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case "USERS_LOADING":
      return {
        ...state,
        status: "loading",
      };
    case "USERS_SUCCESS":
      return {
        ...state,
        status: "success",
        data: payload.data,
        meta: payload.meta,
      };
    case "USERS_FAILURE":
      return {
        ...state,
        status: "failure",
      };
    default:
      return state;
  }
};
